import { render, staticRenderFns } from "./CColorPicker.vue?vue&type=template&id=d8e4b89c&scoped=true"
import script from "./CColorPicker.vue?vue&type=script&setup=true&lang=ts"
export * from "./CColorPicker.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CColorPicker.vue?vue&type=style&index=0&id=d8e4b89c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8e4b89c",
  null
  
)

export default component.exports